export type CategoryItem = {
  label: string;
  href: string;
  image: string;
  badge?: string;
};

export type MegaCategory = {
  title: string;
  href: string;
  badge?: string;
  items: CategoryItem[];
  featured?: CategoryItem;
};

/**
 * Mega menü — genel kategori planı.
 * Kurallar: her href canlı ve dolu sayfaya gider (ölü link yok);
 * Google/Meta tarafında her ürün `taxonomy.ts` ile en spesifik
 * google_product_category yaprağına eşlenir (bkz. app/api/feed).
 */
export const megaCategories: MegaCategory[] = [
  {
    title: "Kalıcı Oje",
    href: "/kategori/kalici-ojeler",
    items: [
      { label: "Tüm Kalıcı Ojeler", href: "/kategori/kalici-ojeler", image: "/images/categories/kalici-ojeler.png" },
      { label: "Renkli Ojeler", href: "/arama?q=kalıcı%20oje", image: "/images/products/uno-color-gel.png" },
      { label: "Base Coat", href: "/arama?q=base%20coat", image: "/images/products/uno-strong.png" },
      { label: "Top Coat", href: "/arama?q=top%20coat", image: "/images/products/uno-diamond.png" },
    ],
  },
  {
    title: "Protez Tırnak",
    href: "/kategori/protez-tirnak",
    items: [
      { label: "Tüm Protez", href: "/kategori/protez-tirnak", image: "/images/categories/protez/cover.jpg" },
      { label: "Jel Tips", href: "/arama?q=jel%20tip", image: "/images/products/soft-gel-tips.png" },
      { label: "Builder & Polygel", href: "/arama?q=polygel", image: "/images/products/protez/protez-polygel-builder-clear.jpg" },
      { label: "Form & Yapıştırıcı", href: "/arama?q=form", image: "/images/products/protez/protez-form-sablonu-100.jpg" },
    ],
  },
  {
    title: "Nail Art",
    href: "/kategori/nail-art-suslemeler",
    items: [
      { label: "Tümü", href: "/kategori/nail-art-suslemeler", image: "/images/categories/manikur.jpg" },
      { label: "Toz & Pigment", href: "/arama?q=toz", image: "/images/products/inci-tozu-gri.png" },
      { label: "Süs & Aksesuar", href: "/arama?q=süs", image: "/images/products/cat-eye-magnet.png" },
      { label: "French", href: "/urunler?stil=french", image: "/images/categories/manikur.jpg" },
    ],
  },
  {
    title: "Kirpik",
    href: "/kategori/kirpik",
    badge: "YENİ",
    items: [
      { label: "Tümü", href: "/kategori/kirpik", image: "/images/categories/bakim.jpg" },
      { label: "İpek Kirpikler", href: "/arama?q=nagaraku", image: "/images/categories/jel-takma.jpg" },
      { label: "Lifting Setleri", href: "/arama?q=lifting", image: "/images/categories/guclendirici.jpg" },
      { label: "Cımbız & Aksesuar", href: "/arama?q=cimbiz", image: "/images/categories/manikur.jpg" },
    ],
  },
  {
    title: "Bakım",
    href: "/kategori/tirnak-bakimi",
    items: [
      { label: "Tüm Bakım", href: "/kategori/tirnak-bakimi", image: "/images/categories/bakim.jpg" },
      { label: "Manikür", href: "/kategori/manikur", image: "/images/categories/manikur.jpg" },
      { label: "Pedikür", href: "/kategori/pedikur", image: "/images/categories/pedikur.jpg" },
      { label: "Törpü & Tampon", href: "/arama?q=törpü", image: "/images/categories/bakim.jpg" },
    ],
  },
  {
    title: "Cihaz & Aksesuar",
    href: "/kategori/firca-aksesuar",
    items: [
      { label: "Fırça & Aksesuar", href: "/kategori/firca-aksesuar", image: "/images/categories/setler.jpg" },
      { label: "UV Kurutucular", href: "/arama?q=uv", image: "/images/categories/bakim.jpg" },
      { label: "Freze", href: "/arama?q=freze", image: "/images/products/protez/protez-frez-uc-seti.jpg" },
      { label: "Fırçalar", href: "/arama?q=fırça", image: "/images/products/glue.png" },
    ],
  },
  {
    title: "Fırsat",
    href: "/koleksiyon/yeni-urunler",
    badge: "AVANTAJLI",
    items: [
      { label: "Yeni Ürünler", href: "/koleksiyon/yeni-urunler", image: "/images/categories/setler.jpg" },
      { label: "Çok Satanlar", href: "/koleksiyon/cok-satanlar", image: "/images/categories/guclendirici.jpg" },
      { label: "İndirimliler", href: "/koleksiyon/indirimliler", image: "/images/categories/manikur.jpg" },
      { label: "Setler", href: "/kategori/setler", image: "/images/categories/setler.jpg" },
    ],
  },
];
